<div class="wrapper" 
	[ngClass]="{
		'selected': selected,
		'has-dragger': dragger !== 'none',
		'no-dragger': dragger === 'none'}">

	<div class="hoverable-area"></div>

	<div class="dragger-wrapper">
		<div *ngIf="dragger === 'keyframe'" class="keyframe"></div>
		<div *ngIf="dragger === 'chapter'" class="chapter">
			<i class="fa fa-circle-o"></i>
			<div class="chapter-icon"></div>
		</div>
	</div>

	<div *ngIf="dragger === 'chapter'" 
		class="chapter-label">
		<input #labelInput
			[formControl]="labelControl"
			(keydown.escape)="labelInput.blur()"
			(keydown.enter)="labelInput.blur()"
			type="text"
			(change)="onLabelInputChange($event, labelControl.value)"
			(mousedown)="onInputMousedown($event)"
			[size]="labelControl.value && labelControl.value !== 0? labelControl.value.length : 1"
			(blur)="editTimepoint(false)"
			(focus)="editTimepoint(true)"/>
	</div>

	<div *ngIf="dragger === 'chapter' && (!editMode && offsetDifference > 20)" class="gradient"></div>
	
	<bb-check
		[ngClass]="{'app-left': true}"
		*ngIf="tooltip === 'left' && dragger === 'none'"
		[hidden]="!editMode && interactivityEditorService.parentEntityType !== 'App' && interactivityEditorService.parentEntityType !== 'Project'"
		[(ngModel)]="obeyTimelineShow"
		(onChanged)="onUpdateIgnoreShow($event)"
		title="{{ 'ENFORCE_START_TIME' | translate }}"
	></bb-check>

	<bb-timecode-editor *ngIf="interactivityEditorService.parentEntityType !== 'App' && interactivityEditorService.parentEntityType !== 'Project'" #timepointInput 
		(keydown.escape)="timepointInput.blur()"
		(keydown.enter)="timepointInput.blur()"
		[min]="0"
		[max]="maxTime"
		[hidden]="tooltip === 'hide'"
		type="text"
		class="time-tooltip"
		[ngClass]="{'show-hide' : dragger === 'none'}"
		[formControl]="timepointControl"
		(change)="changeTimepoint(timepointControl.value)"
		(mousedown)="onInputMousedown($event)"
		(onBlur)="editTimepoint(false)"
		(onFocus)="editTimepoint(true)">
	</bb-timecode-editor>

	<bb-check [ngClass]="{'app-right': true}" *ngIf="tooltip === 'right' && dragger === 'none'"
		[hidden]="!editMode && interactivityEditorService.parentEntityType !== 'App' && interactivityEditorService.parentEntityType !== 'Project'" [(ngModel)]="obeyTimelineHide" (onChanged)="onUpdateIgnoreHide($event)" title="{{ 'ENFORCE_END_TIME' | translate }}"
	></bb-check>
</div>
